<template>
	<div class="conversation">
		<el-row>
			<el-col :span="12">
				<div v-loading="isLoading" style="width: 425px">
					<!-- 欢迎语文本设置 -->
					<div class="welcome-txt">欢迎语文本设置</div>
					<div class="card">
						<span>欢迎语文本</span>
						<span v-show="!editVisible" @click="editVisible = true">
							<ig-icon name="bianji1" style="float: right; cursor: pointer"></ig-icon>
						</span>
						<div class="txt" v-show="!editVisible">
							<span>{{ dialogue }}</span>
						</div>
						<div v-show="editVisible" class="edit">
							<el-input type="textarea" v-model="conversation"></el-input>
							<div style="margin-top: 10px">
								<el-button type="primary" size="medium" @click="submit">保存</el-button>
								<el-button @click="welExit" size="medium">取消</el-button>
							</div>
						</div>
					</div>
					<!-- 欢迎语按钮设置 -->
					<div class="welcome-txt">欢迎语按钮设置</div>
					<div v-for="(item, index) in menuList" :key="index" style="width: 425px">
						<div class="btn">
							<span style="margin-right: 10px">{{ item.btntitle }}</span>
							<el-tooltip
								v-show="item.btntitle !== '自定义按钮'"
								effect="dark"
								:content="item.tips"
								placement="top-start"
							>
								<ig-icon name="tishi"></ig-icon>
							</el-tooltip>
							<el-switch
								:active-value="1"
								:inactive-value="0"
								v-model="item.btnStatus"
								@change="changeinfo"
								style="float: right"
							></el-switch>
						</div>
						<div class="card" v-for="(ele, i) in item.btnpanl" :key="i">
							<span>{{ ele.btnpanltitle }}</span>
							<span
								v-if="flag_a !== index || flag_b !== i"
								@click="
									flag_a = index;
									flag_b = i;
								"
							>
								<ig-icon name="bianji1" style="float: right; cursor: pointer"></ig-icon>
							</span>
							<div class="txt" v-if="flag_a !== index || flag_b !== i">
								<span>{{ ele.displayContent }}</span>
							</div>
							<div v-if="flag_a == index && flag_b == i" class="edit">
								<el-input
									type="textarea"
									v-model="ele.btnpanlContent"
									:maxlength="ele.max_length"
									show-word-limit
									@input="judgeNull(ele)"
								></el-input>
								<div style="margin-top: 10px">
									<el-button type="primary" size="medium" @click="submit" :disabled="ele.isdisable"
										>保存</el-button
									>
									<el-button @click="buttonExit(ele)" size="medium">取消</el-button>
								</div>
							</div>
						</div>
						<div class="line"></div>
					</div>
					<!-- 请求邮箱设置  -->
					<div class="welcome-txt">请求邮箱/手机号设置</div>
					<div class="btn">
						<span>欢迎语发送后，紧接着主动向客户请求一次邮箱/手机号</span>
						<el-switch
							:active-value="1"
							:inactive-value="0"
							v-model="youxiang"
							@change="changeinfo"
							style="float: right"
						></el-switch>
					</div>
					<div class="card">
						<span>*发送内容</span>
						<span v-show="!emailVisible" @click="emailVisible = true">
							<ig-icon name="bianji1" style="float: right; cursor: pointer"></ig-icon>
						</span>
						<div class="txt" v-show="!emailVisible">
							<span>{{ emailContent }}</span>
						</div>
						<div v-show="emailVisible" class="edit">
							<el-input type="textarea" v-model="requireemailtxt" @input="judge"></el-input>
							<div style="margin-top: 10px">
								<el-button type="primary" size="medium" @click="submit" :disabled="disable"
									>保存</el-button
								>
								<el-button @click="emailExit" size="medium">取消</el-button>
							</div>
						</div>
					</div>
				</div>
			</el-col>
			<!-- mobilePhone -->
			<el-col :span="12">
				<div class="show-data">
					<div class="thumb">
						<img :src="thumb ? thumb : require('@/assets/staffPhoto1.png')" class="thumb-l" />
					</div>
					<div class="name">
						{{ name ? name : '-' }}
					</div>
					<div class="avatar">
						<img :src="thumb ? thumb : require('@/assets/staffPhoto1.png')" class="avatar-l" />
					</div>
					<div class="content">
						<div class="wel">{{ dialogue ? dialogue : '-' }}</div>
						<div class="btn-min" v-for="(item, index) in menuList" :key="index">
							<el-button v-if="index == 0 && item.btnStatus == '1'" type="primary" round>
								<div class="btn_txt">
									{{ item.btnpanl[0].displayContent }}
								</div>
							</el-button>
							<el-button v-else-if="item.btnStatus == '1'" round>
								<div class="btn_txt">
									{{ item.btnpanl[0].displayContent }}
								</div>
							</el-button>
						</div>
					</div>
					<div v-if="youxiang" class="avatar">
						<img :src="thumb ? thumb : require('@/assets/staffPhoto1.png')" class="avatar-l" />
					</div>
					<div v-if="youxiang" class="content">
						<div class="wel">{{ emailContent }}</div>
					</div>
				</div>
			</el-col>
		</el-row>
	</div>
</template>
<script>
export default {
	props: [
		'dialogue',
		'emailOpenFlag',
		'emailName',
		'staffServiceOpenFlag',
		'staffServiceName',
		'staffServiceContent',
		'visitWebsiteOpenFlag',
		'visitWebsiteName',
		'visitWebsiteContent',
		'email',
		'emailContent',
		'thumb',
		'name',
	],
	data() {
		return {
			menuList: [
				{
					btntitle: '向客户请求邮箱',
					tips: '客户点击此按钮后，可以快速选择并向公共主页发送自己的邮箱',
					btnStatus: '',
					btnpanl: [
						{
							btnpanltitle: '*按钮名称',
							btnpanlContent: '',
							max_length: 30,
							isdisable: false,
							displayContent: '',
						},
					],
				},
				{
					btntitle: '自定义按钮',
					btnStatus: '',
					btnpanl: [
						{
							btnpanltitle: '*按钮名称',
							btnpanlContent: '',
							max_length: 30,
							isdisable: false,
							displayContent: '',
						},
						{
							btnpanltitle: '*自动回复',
							btnpanlContent: '',
							isdisable: false,
							displayContent: '',
						},
					],
				},
				{
					btntitle: '访问网址',
					tips: '客户点击此按钮后，主页将向他发送以下设置的网址，默认为网站首页',
					btnStatus: '',
					btnpanl: [
						{
							btnpanltitle: '*按钮名称',
							btnpanlContent: '',
							max_length: 30,
							isdisable: false,
							displayContent: '',
						},
						{
							btnpanltitle: '*网址',
							btnpanlContent: '',
							isdisable: false,
							displayContent: '',
						},
					],
				},
			],
			editVisible: false,
			emailVisible: false,
			disable: false,
			flag_a: 'a',
			flag_b: 'b',
			conversation: '',
			youxiang: '',
			requireemailtxt: '',
			isLoading: false,
		};
	},
	methods: {
		computedByteLen(txt) {
			let temp = 0;
			for (let i = 0; i < txt.length; i++) {
				if (/[^\x00-\xff]/.test(txt[i])) {
					temp += 2;
				} else {
					temp++;
				}
				if (temp > 80) {
					txt = txt.substr(0, i);
				}
			}
			this.conversation = txt;
		},

		judgeNull(pre) {
			if (pre.btnpanlContent == '') {
				pre.isdisable = true;
			} else {
				pre.isdisable = false;
			}
		},
		judge() {
			if (this.requireemailtxt == '') {
				this.disable = true;
			} else {
				this.disable = false;
			}
		},
		welExit() {
			this.editVisible = false;
			this.conversation = this.dialogue;
		},
		buttonExit(pre) {
			this.flag_a = 'a';
			this.flag_b = 'b';
			pre.btnpanlContent = pre.displayContent;
		},
		emailExit() {
			this.emailVisible = false;
			this.requireemailtxt = this.emailContent;
		},

		submit() {
			this.changeinfo();
			this.editVisible = false;
			this.emailVisible = false;
			this.flag_a = 'a';
			this.flag_b = 'b';
		},

		changeinfo() {
			this.isLoading = true;
			this.$emit(
				'changeconversation',
				this.conversation,
				this.menuList,
				this.youxiang,
				this.requireemailtxt,
				this.resetLoading
			);
		},
		resetLoading() {
			this.isLoading = false;
		},
	},
	watch: {
		dialogue: {
			handler(val) {
				this.conversation = val;
			},
			immediate: true,
		},
		emailOpenFlag: {
			handler(val) {
				this.menuList[0].btnStatus = val;
			},
			immediate: true,
		},
		emailName: {
			handler(val) {
				this.menuList[0].btnpanl[0].btnpanlContent = val;
				this.menuList[0].btnpanl[0].displayContent = val;
			},
			immediate: true,
		},
		staffServiceOpenFlag: {
			handler(val) {
				this.menuList[1].btnStatus = val;
			},
			immediate: true,
		},
		staffServiceName: {
			handler(val) {
				this.menuList[1].btnpanl[0].btnpanlContent = val;
				this.menuList[1].btnpanl[0].displayContent = val;
			},
			immediate: true,
		},
		staffServiceContent: {
			handler(val) {
				this.menuList[1].btnpanl[1].btnpanlContent = val;
				this.menuList[1].btnpanl[1].displayContent = val;
			},
			immediate: true,
		},
		visitWebsiteOpenFlag: {
			handler(val) {
				this.menuList[2].btnStatus = val;
			},
			immediate: true,
		},
		visitWebsiteName: {
			handler(val) {
				this.menuList[2].btnpanl[0].btnpanlContent = val;
				this.menuList[2].btnpanl[0].displayContent = val;
			},
			immediate: true,
		},
		visitWebsiteContent: {
			handler(val) {
				this.menuList[2].btnpanl[1].btnpanlContent = val;
				this.menuList[2].btnpanl[1].displayContent = val;
			},
			immediate: true,
		},
		email: {
			handler(val) {
				this.youxiang = val;
			},
			immediate: true,
		},
		emailContent: {
			handler(val) {
				this.requireemailtxt = val;
			},
			immediate: true,
		},
	},
};
</script>
<style lang="scss" scoped>
.conversation {
	margin-left: 60px;
	margin-bottom: 40px;

	.welcome-txt {
		margin-top: 40px;
		width: 425px;
		line-height: 0px;
		padding: 20px;
		font-size: 16px;
		background: #eee;
		border-radius: 2px;
	}

	.btn {
		width: 425px;
		margin-top: 20px;
		font-size: 14px;
		font-weight: 500;
	}

	.card {
		margin-top: 25px;
		width: 425px;

		.txt {
			margin-top: 15px;
			font-size: 13px;
			font-weight: 500;
		}

		.edit {
			margin-top: 10px;
		}
	}

	.line {
		margin-top: 10px;
		width: 425px;
		height: 5px;
		border-bottom: 1px solid #acc0d8;
	}

	.show-data {
		margin: 100px auto;
		width: 370px;
		height: 739px;
		line-height: 16px;
		padding: 52px 25px 0;
		background-image: url(https://img.iglobalwin.com/image/mobile.png);
		background-size: 100%;
		background-repeat: no-repeat;

		.thumb {
			margin: 20px auto;
			width: 60px;
			height: 60px;

			.thumb-l {
				width: 60px;
				height: 60px;
				border-radius: 50%;
			}
		}

		.name {
			margin: 0 auto;
			text-align: center;
			font-size: 18px;
			font-weight: 500;
		}

		.avatar {
			margin-top: 20px;
			width: 40px;
			height: 40px;

			.avatar-l {
				width: 40px;
				height: 40px;
				border-radius: 50%;
			}
		}

		.content {
			margin: -7px auto;
			width: 230px;
			border: 2px solid rgb(179, 177, 177);
			border-radius: 7px;

			.wel {
				width: 200px;
				overflow: auto;
				margin: 0 auto;
				padding: 10px;
				font-size: 14px;
			}

			.btn-min {
				margin: 10px auto;
				text-align: center;

				.btn_txt {
					width: 150px;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
				}
			}
		}
	}
}
</style>
